// extracted by mini-css-extract-plugin
export var LanguageSelector = "navMobile-module--LanguageSelector--9f953";
export var LanguageSelector_current = "navMobile-module--LanguageSelector_current--b3f96";
export var NavMenu = "navMobile-module--NavMenu--34e06";
export var NavMenu___closing = "navMobile-module--NavMenu___closing--cbd22";
export var NavMenu_accordion = "navMobile-module--NavMenu_accordion--302a9";
export var NavMenu_link = "navMobile-module--NavMenu_link--5c865";
export var NavMobile = "navMobile-module--NavMobile--939aa";
export var NavMobile_logo = "navMobile-module--NavMobile_logo--c6c51";
export var NavMobile_menuButton = "navMobile-module--NavMobile_menuButton--7c7aa";
export var NavMobile_navBar = "navMobile-module--NavMobile_navBar--43673";
export var NavSearch = "navMobile-module--NavSearch--d829f";
export var NavSearch_icon = "navMobile-module--NavSearch_icon--7ca25";
export var NavSearch_submit = "navMobile-module--NavSearch_submit--d0a25";
export var navMenuSlideDown = "navMobile-module--nav-menu-slide-down--caef0";
export var navMenuSlideUp = "navMobile-module--nav-menu-slide-up--e7d66";
export var slideIn = "navMobile-module--slide-in--3b27b";
export var slideInFromRight = "navMobile-module--slide-in-from-right--d9a73";